export default __webpack_public_path__ + "static/media/growthstudiovideo.25395c80.mp4";